import React, { useState, useEffect } from 'react';

function PeoplePopupModal({ show, onClose, onSubmit, defaultValue, onImageChange }) {
  const [name, setName] = useState('');
  const [researchArea, setResearchArea] = useState('');
  const [status, setStatus] = useState('');
  const [year, setYear] = useState('');

  useEffect(() => {
    if (defaultValue) {
      setName(defaultValue.name || '');
      setResearchArea(defaultValue.researchArea || '');
      setStatus(defaultValue.status || '');
      setYear(defaultValue.year || '');
    } else {
      setName('');
      setResearchArea('');
      setStatus('');
      setYear('');
    }
  }, [defaultValue]);

  const handleSubmit = () => {
    const data = { name, researchArea, status, year };
    onSubmit(data);
  };

  if (!show) return null;

  const styles = {
    modal: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      zIndex: 1000,
      width: '400px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 999,
    },
    inputGroup: {
      marginBottom: '15px',
    },
    label: {
      display: 'block',
      marginBottom: '5px',
      fontWeight: 'bold',
    },
    input: {
      width: '100%',
      padding: '8px',
      borderRadius: '4px',
      border: '1px solid #ccc',
    },
    buttonContainer: {
      textAlign: 'right',
      marginTop: '20px',
    },
    button: {
      padding: '10px 20px',
      backgroundColor: '#007BFF',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
    },
    cancelButton: {
      marginRight: '10px',
      backgroundColor: '#6c757d',
    },
  };

  const renderInput = (label, value, onChange, type = 'text') => (
    <div style={styles.inputGroup}>
      <label style={styles.label}>{label}</label>
      <input
        type={type}
        value={value}
        onChange={onChange}
        style={styles.input}
      />
    </div>
  );

  return (
    <>
      <div style={styles.overlay} onClick={onClose}></div>
      <div style={styles.modal}>
        {renderInput('Name', name, (e) => setName(e.target.value))}
        {renderInput('Research Area', researchArea, (e) => setResearchArea(e.target.value))}
        {renderInput('Status', status, (e) => setStatus(e.target.value))}
        {renderInput('Year', year, (e) => setYear(e.target.value))}
        <div style={styles.buttonContainer}>
          <button
            style={{ ...styles.button, ...styles.cancelButton }}
            onClick={onClose}
          >
            Cancel
          </button>
          <button style={styles.button} onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </>
  );
}

export default PeoplePopupModal;